import { useCallback } from 'react'
import { EmployerMetaField } from 'Services/employerService'
import { UserWithMetadata } from 'Services/apiResponseTypes'
import { CellChange, GridColumnKind, changeKey } from '../gridModel'

export const useMetadataValidation = (
  metaFields: EmployerMetaField[],
  users: UserWithMetadata[]
) => {
  const validateField = useCallback(
    (
      userId: number,
      kind: GridColumnKind,
      fieldName: string,
      value: string | null,
      currentChanges: Map<string, CellChange>
    ): string | null => {
      if (kind === 'userField') {
        return value && value.trim() !== '' ? null : 'Required'
      }

      const field = metaFields.find((f) => f.fieldName === fieldName)
      if (!field) return null

      if (field.required && (!value || value.trim() === '')) {
        return 'Required'
      }

      if (field.unique && value && value.trim() !== '') {
        const trimmedValue = value.trim()
        const isEdited =
          value !== users.find((user) => user.user_id === userId)?.metadata[fieldName]
        const hasDuplicate = users.some((user) => {
          if (user.user_id === userId) return false

          const change = currentChanges.get(changeKey(user.user_id, kind, fieldName))
          if (!isEdited && !change) return false

          const finalValue = change ? change.newValue : user.metadata[fieldName]

          return finalValue && finalValue.trim() === trimmedValue
        })

        if (hasDuplicate) {
          return 'Must be unique'
        }
      }

      return null
    },
    [metaFields, users]
  )

  return { validateField }
}
